import {AnyAction, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IBottomBarState} from 'modules/bottom-bar/types';
import {HYDRATE} from 'next-redux-wrapper';
import {IRootReducer} from 'core/redux/reducers';

export const bottomBarModuleName = 'bottomBar';

const initialState: IBottomBarState = {
    activeItem: 'main',
    prevActiveItem: 'main',
};

export const bottomBarSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action: AnyAction) => {
            const payload = action.payload as IRootReducer | undefined;
            if (!payload) {
                return state;
            }

            return payload[bottomBarModuleName];
        });
    },
    initialState,
    name: bottomBarModuleName,
    reducers: {
        actionSetActive(state, {payload}: PayloadAction<IBottomBarState['activeItem']>) {
            state.prevActiveItem = state.activeItem;
            state.activeItem = payload;
        },
    },
});

export const {
    actions: {actionSetActive},
} = bottomBarSlice;

export const {reducer: bottomBarReducer} = bottomBarSlice;
